import React from 'react'

export default React.createContext()



// WEBPACK FOOTER //
// ./src/components/UserAccountEditor/toggleModalObscuredContext.js